import React from 'react';
import { styled } from '@linaria/react';
import { FilterSource } from 'components/Accommodation/OffersFilters/constants';
import { SoldOutBase } from 'components/Unavailability/SoldOut/SoldOutBase';
import { useHotelOverlayOffersFilters } from 'hooks/useHotelOverlayOffersFilters';
import { Button } from '@daedalus/atlas/Button';
import { Card } from '@daedalus/atlas/Card';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
interface Props {
  source: FilterSource;
}
const _exp = /*#__PURE__*/() => Button;
const RemoveFiltersButton = /*#__PURE__*/styled(_exp())({
  name: "RemoveFiltersButton",
  class: "rkyxmy4",
  propsAsIs: true
});
const _exp3 = /*#__PURE__*/() => Card;
const UnavailabilityWrapper = /*#__PURE__*/styled(_exp3())({
  name: "UnavailabilityWrapper",
  class: "ujtko3x",
  propsAsIs: true
});
export const UnavailabilityWithFilters = ({
  source
}: Props) => {
  const {
    setFilters
  } = useHotelOverlayOffersFilters();
  const onRemoveFilters = () => {
    setFilters([], source);
  };
  return <UnavailabilityWrapper borderRadius="lg" borderColorPath="border.neutral.c100" isOverflowHidden={false}>
      <ContentWrapper padding="s400">
        <SoldOutBase headerSlot={<FormattedMessageWrapper id="unavailability.soldOutWithFilters" defaultMessage="No deals to show" />} contentSlot={<FormattedMessageWrapper id="unavailability.soldOutWithFiltersBody" defaultMessage="Change or remove applied filters to see the results." />} actionSlot={<RemoveFiltersButton variant="secondary" fullWidth onClick={onRemoveFilters}>
              <FormattedMessageWrapper id="removeFiltersMessage" defaultMessage="Remove filters" />
            </RemoveFiltersButton>} />
      </ContentWrapper>
    </UnavailabilityWrapper>;
};

require("./UnavailabilityWithFilters.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./UnavailabilityWithFilters.tsx");